import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardHeader,
  Chip,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

const UserList = ({ users, onUserClick }) => {
  return (
    <Grid container spacing={2}>
      {users?.map((user, index) => (
        <Grid
          size={{ lg: 4, md: 6, sm: 12, xs: 12 }}
          key={user.id}
          onClick={() => onUserClick(user)}
        >
          <Card variant="outlined">
            <Box
              display="flex"
              alignItems="center"
              flexWrap={{
                md: "nowrap",
                xs: "wrap",
              }}
              p={1}
              gap={2}
            >
              <Avatar
                variant="rounded"
                alt={user.name}
                src={require(`../../../assets/img/profiles/p${index + 1}.jpg`)}
                sx={{
                  width: 50,
                  height: 50,
                }}
              />
              <Box>
                <Typography variant="body1" fontWeight={500}>
                  {user.name},{" "}
                  <Typography
                    fontSize={10}
                    color="text.secondary"
                    component="span"
                  >
                    {user?.age || "N/A"} yrs
                  </Typography>
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  {user?.mobile}
                </Typography>
                <Box
                  display="flex"
                  gap={1}
                  mt={0.5}
                  flexWrap={{
                    md: "nowrap",
                    xs: "wrap",
                  }}
                >
                  <Chip
                    label={
                      <Box display="flex" alignItems="center" gap={0.5}>
                        <Typography fontSize={12} color="text.secondary">
                          {user?.horoscope || "No Horoscope"}
                        </Typography>
                      </Box>
                    }
                    size="small"
                    variant="outlined"
                  />
                  <Chip
                    label={
                      <Typography fontSize={12} color="text.secondary">
                        {user.description}
                      </Typography>
                    }
                    size="small"
                  />
                </Box>
              </Box>
            </Box>
            {/* <Divider /> */}
            {/* <Box display="flex" justifyContent="end" p={1} gap={2}>
              <IconButton
                sx={{
                  width: 20,
                  height: 20,
                }}
              >
                <RemoveRedEyeIcon
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
              <IconButton
                sx={{
                  width: 20,
                  height: 20,
                }}
              >
                <EditIcon
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Box> */}
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
export default UserList;
